// Support tickets v2 (guided form, categories, admin e-mail)
const en = {
  "tk.newTitle": "Create a New Support Ticket",
  "tk.newIntro": "Fill in the form step by step. You'll see new fields appear as you go. This helps us get your ticket to the right team quickly.",
  "tk.back": "Back to support",
  "tk.category": "Ticket Category",
  "tk.categoryPlaceholder": "Select a category",
  "tk.cat.bug_error": "Bug/Error",
  "tk.cat.manage_music": "Manage Music",
  "tk.cat.payments": "Payments",
  "tk.cat.eam_direct": "EAM Direct",
  "tk.cat.sales_reporting": "Sales Reporting",
  "tk.cat.uploading": "Uploading",
  "tk.cat.revenue_share": "Request for Revenue Share",
  "tk.cat.other": "Other",
  "tk.cat.legacyRelease": "Release",
  "tk.cat.legacyAccount": "Account",
  "tk.releases": "Release UPC Number(s)",
  "tk.releasesRequired": "Select at least one release for this category.",
  "tk.releasesOptional": "Optional — add the releases this ticket is about.",
  "tk.releasesSearch": "Search by release title or UPC",
  "tk.releasesEmpty": "No releases found",
  "tk.releasesNoUpc": "No UPC yet",
  "tk.subject": "Ticket Subject",
  "tk.subjectPlaceholder": "Ticket Subject",
  "tk.message": "Your Message",
  "tk.messagePlaceholder": "Tell us about your problem...",
  "tk.messageMin": "At least {n} characters",
  "tk.attach": "Attach File(s)",
  "tk.attachDrop": "Drag file(s) here to upload or",
  "tk.attachBrowse": "Browse Computer",
  "tk.attachHint": "JPEG, PNG, WebP or PDF · max 10 MB · up to 5 files",
  "tk.attachInvalid": "Unsupported file type: {name}",
  "tk.attachTooBig": "File is larger than 10 MB: {name}",
  "tk.attachMax": "You can attach up to 5 files.",
  "tk.attachFailed": "Could not upload {name}",
  "tk.uploading": "Uploading…",
  "tk.submit": "Submit Ticket",
  "tk.submitting": "Submitting…",
  "tk.created": "Ticket {n} created",
  "tk.createdDesc": "Our team has been notified. You'll get updates here and by e-mail.",
  "tk.failed": "The ticket could not be created",
  "tk.err.release_required": "Please select at least one release.",
  "tk.err.invalid_category": "Please choose a category.",
  "tk.number": "Ticket",
  "tk.relatedReleases": "Related releases",
  "tk.sentByEmail": "Sent by e-mail",
  "tk.emailNotDelivered": "E-mail not delivered",
  "tk.email.button": "Send e-mail",
  "tk.email.title": "E-mail the artist",
  "tk.email.desc": "The message is sent to {email} and added to the ticket thread.",
  "tk.email.subject": "Subject",
  "tk.email.message": "Message",
  "tk.email.addToThread": "Also add to the ticket thread",
  "tk.email.send": "Send",
  "tk.email.sent": "E-mail sent to {email}",
  "tk.email.notConfigured": "Saved to the thread, but the e-mail service is not configured (RESEND_API_KEY).",
  "tk.email.failed": "E-mail could not be sent",
};
const tr = {
  "tk.newTitle": "Yeni Destek Talebi Oluştur",
  "tk.newIntro": "Formu adım adım doldur. İlerledikçe yeni alanlar açılacak. Bu, talebini doğru ekibe hızlıca ulaştırmamıza yardımcı olur.",
  "tk.back": "Desteğe dön",
  "tk.category": "Talep Kategorisi",
  "tk.categoryPlaceholder": "Bir kategori seç",
  "tk.cat.bug_error": "Hata/Sorun",
  "tk.cat.manage_music": "Müzik Yönetimi",
  "tk.cat.payments": "Ödemeler",
  "tk.cat.eam_direct": "EAM Direct",
  "tk.cat.sales_reporting": "Satış Raporları",
  "tk.cat.uploading": "Yükleme",
  "tk.cat.revenue_share": "Gelir Paylaşımı Talebi",
  "tk.cat.other": "Diğer",
  "tk.cat.legacyRelease": "Yayın",
  "tk.cat.legacyAccount": "Hesap",
  "tk.releases": "Yayın UPC Numara(ları)",
  "tk.releasesRequired": "Bu kategori için en az bir yayın seç.",
  "tk.releasesOptional": "İsteğe bağlı — talebin ilgili olduğu yayınları ekle.",
  "tk.releasesSearch": "Yayın adı veya UPC ile ara",
  "tk.releasesEmpty": "Yayın bulunamadı",
  "tk.releasesNoUpc": "Henüz UPC yok",
  "tk.subject": "Talep Konusu",
  "tk.subjectPlaceholder": "Talep Konusu",
  "tk.message": "Mesajın",
  "tk.messagePlaceholder": "Sorununu bize anlat...",
  "tk.messageMin": "En az {n} karakter",
  "tk.attach": "Dosya Ekle",
  "tk.attachDrop": "Dosyaları buraya sürükle veya",
  "tk.attachBrowse": "Bilgisayardan Seç",
  "tk.attachHint": "JPEG, PNG, WebP veya PDF · en fazla 10 MB · 5 dosyaya kadar",
  "tk.attachInvalid": "Desteklenmeyen dosya türü: {name}",
  "tk.attachTooBig": "Dosya 10 MB'tan büyük: {name}",
  "tk.attachMax": "En fazla 5 dosya ekleyebilirsin.",
  "tk.attachFailed": "{name} yüklenemedi",
  "tk.uploading": "Yükleniyor…",
  "tk.submit": "Talebi Gönder",
  "tk.submitting": "Gönderiliyor…",
  "tk.created": "{n} numaralı talep oluşturuldu",
  "tk.createdDesc": "Ekibimize bildirildi. Güncellemeleri burada ve e-postayla alacaksın.",
  "tk.failed": "Talep oluşturulamadı",
  "tk.err.release_required": "Lütfen en az bir yayın seç.",
  "tk.err.invalid_category": "Lütfen bir kategori seç.",
  "tk.number": "Talep",
  "tk.relatedReleases": "İlgili yayınlar",
  "tk.sentByEmail": "E-postayla gönderildi",
  "tk.emailNotDelivered": "E-posta iletilemedi",
  "tk.email.button": "E-posta gönder",
  "tk.email.title": "Sanatçıya e-posta gönder",
  "tk.email.desc": "Mesaj {email} adresine gönderilir ve talep geçmişine eklenir.",
  "tk.email.subject": "Konu",
  "tk.email.message": "Mesaj",
  "tk.email.addToThread": "Talep geçmişine de ekle",
  "tk.email.send": "Gönder",
  "tk.email.sent": "E-posta gönderildi: {email}",
  "tk.email.notConfigured": "Talep geçmişine kaydedildi ama e-posta servisi yapılandırılmamış (RESEND_API_KEY).",
  "tk.email.failed": "E-posta gönderilemedi",
};
const es = {
  "tk.newTitle": "Crear un nuevo ticket de soporte",
  "tk.newIntro": "Completa el formulario paso a paso. Verás aparecer nuevos campos a medida que avanzas. Así llevamos tu ticket al equipo correcto rápidamente.",
  "tk.back": "Volver a soporte",
  "tk.category": "Categoría del ticket",
  "tk.categoryPlaceholder": "Elige una categoría",
  "tk.cat.bug_error": "Error/Fallo",
  "tk.cat.manage_music": "Gestionar música",
  "tk.cat.payments": "Pagos",
  "tk.cat.eam_direct": "EAM Direct",
  "tk.cat.sales_reporting": "Informes de ventas",
  "tk.cat.uploading": "Subida",
  "tk.cat.revenue_share": "Solicitud de reparto de ingresos",
  "tk.cat.other": "Otro",
  "tk.cat.legacyRelease": "Lanzamiento",
  "tk.cat.legacyAccount": "Cuenta",
  "tk.releases": "Número(s) UPC del lanzamiento",
  "tk.releasesRequired": "Selecciona al menos un lanzamiento para esta categoría.",
  "tk.releasesOptional": "Opcional — añade los lanzamientos relacionados.",
  "tk.releasesSearch": "Buscar por título o UPC",
  "tk.releasesEmpty": "No se encontraron lanzamientos",
  "tk.releasesNoUpc": "Sin UPC aún",
  "tk.subject": "Asunto del ticket",
  "tk.subjectPlaceholder": "Asunto del ticket",
  "tk.message": "Tu mensaje",
  "tk.messagePlaceholder": "Cuéntanos tu problema...",
  "tk.messageMin": "Al menos {n} caracteres",
  "tk.attach": "Adjuntar archivo(s)",
  "tk.attachDrop": "Arrastra archivos aquí o",
  "tk.attachBrowse": "Buscar en el equipo",
  "tk.attachHint": "JPEG, PNG, WebP o PDF · máx. 10 MB · hasta 5 archivos",
  "tk.attachInvalid": "Tipo de archivo no compatible: {name}",
  "tk.attachTooBig": "El archivo supera 10 MB: {name}",
  "tk.attachMax": "Puedes adjuntar hasta 5 archivos.",
  "tk.attachFailed": "No se pudo subir {name}",
  "tk.uploading": "Subiendo…",
  "tk.submit": "Enviar ticket",
  "tk.submitting": "Enviando…",
  "tk.created": "Ticket {n} creado",
  "tk.createdDesc": "Nuestro equipo ha sido notificado. Recibirás novedades aquí y por e-mail.",
  "tk.failed": "No se pudo crear el ticket",
  "tk.err.release_required": "Selecciona al menos un lanzamiento.",
  "tk.err.invalid_category": "Elige una categoría.",
  "tk.number": "Ticket",
  "tk.relatedReleases": "Lanzamientos relacionados",
  "tk.sentByEmail": "Enviado por e-mail",
  "tk.emailNotDelivered": "E-mail no entregado",
  "tk.email.button": "Enviar e-mail",
  "tk.email.title": "Enviar e-mail al artista",
  "tk.email.desc": "El mensaje se envía a {email} y se añade al historial del ticket.",
  "tk.email.subject": "Asunto",
  "tk.email.message": "Mensaje",
  "tk.email.addToThread": "Añadir también al historial",
  "tk.email.send": "Enviar",
  "tk.email.sent": "E-mail enviado a {email}",
  "tk.email.notConfigured": "Guardado en el historial, pero el servicio de e-mail no está configurado (RESEND_API_KEY).",
  "tk.email.failed": "No se pudo enviar el e-mail",
};
export default { en, tr, es };
